<div class="team-card">
    <div class="team-card-head">{{team.teamStatus}}</div>
<div class="team-card-body">
        {{team.player1.playerName}}<br>
        {{team.player2.playerName}}
</div>
</div>